import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseAdministrativeService } from 'src/app/services/warehouse-administrative.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { UserSaved } from 'src/app/models/user.model';
import { CompanyAdministrativeService } from 'src/app/services/company-administrative.service';
import { CompanyService } from 'src/app/services/company.service';
import { CompanyDataResponse, CompanyResponse } from 'src/app/models/company.model';
import { CompanyInvoiceRoutingService } from 'src/app/services/company-invoice-routing.service';

interface RelationCompanyRow {
  companyPurchase: CompanyDataResponse;
  companyPurchaseId: any;
  companySaleId?: any;
  relationId?: any;
  percentage?: number;
}


@Component({
  selector: 'app-administrative-auto-sale-purchase',
  templateUrl: './administrative-auto-sale-purchase.component.html',
  styleUrls: ['./administrative-auto-sale-purchase.component.scss']
})
export class AdministrativeAutoSalePurchaseComponent {

  administrativeId = null;
  fiscalId = null;
  isAdministrative = false;
  warehousesAdministrative = [];
  user: UserSaved = null;
  warehousesFiscales = [];
  originalRelations = [];
  relatedAdministrative: CompanyDataResponse [] = [];
  relationRows: RelationCompanyRow [] = [];

  constructor(
    private warehouseAdministrativeService: WarehouseAdministrativeService,
    private companyAdministrativeService: CompanyAdministrativeService,
    private companyInvoiceRoutingService: CompanyInvoiceRoutingService,
    private toastService: ToastrService,
    private authService: AuthenticationService,
  ){
    this.isAdministrative = JSON.parse(this.authService.getCurrentCompany()).administrative;
    this.administrativeId = JSON.parse(this.authService.getCurrentCompany()).companyId;
    this.user = this.authService.getUser();
    this.loadStartData();
  }

  loadStartData() {
    this.getCompaniesRelatedAdministrative();
  }

  getCompaniesRelatedAdministrative() {
    this.companyAdministrativeService.getRelatedCompaniesDataByCompany(this.administrativeId).subscribe({
      next: (response: ResponseObject) => {
        this.relatedAdministrative = response.data;
        this.getCompaniesRelated();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message || 'Error al obtener las empresas');
      }
    });
  }

  getCompaniesRelated() {
    this.relationRows = [];
    this.relatedAdministrative.forEach(element => {
      this.relationRows.push({
        companyPurchase: element,
        companyPurchaseId: element.id,
        companySaleId: null,
        relationId: null,
        percentage: 0
      });
    });

    this.companyInvoiceRoutingService.getAllCompaniesRelated().subscribe({
      next: (response: ResponseObject) => {
        const data = response.data ?? [];
        data.forEach(element => {
          this.relationRows.forEach(element2 => {
            if (element.companyPurchase==element2.companyPurchaseId) {
              element2.companySaleId = element.companySale
              element2.relationId = element.id
              element2.percentage = element.percentage ?? 0
            }
          })
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message || 'Error al obtener las empresas relaciones compra/venta');
      }
    });
  }

  saveRelated(item: RelationCompanyRow) {
    const companySale = item.companySaleId;
    const companyPurchase = item.companyPurchaseId;
    const relationId = item.relationId;
    const percentage = item.percentage ?? 0;

    if (percentage < 0 || percentage > 100) {
      this.toastService.error('El porcentaje debe estar entre 0 y 100');
      return;
    }
    
    if (relationId==null) {
      this.companyInvoiceRoutingService.postRelatedCompaniesInvoice(companyPurchase, companySale, percentage).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success('Relación creada correctamente');
          this.loadStartData();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message || 'Error al guardar relación');
        }
      });
    } else {
      if (companySale==null) {
        this.removeRelation(relationId);
        return;
      }
      this.companyInvoiceRoutingService.postRelatedCompaniesInvoiceByRelation(companyPurchase, companySale, relationId, percentage).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success('Relación actualizada correctamente');
          this.loadStartData();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message || 'Error al guardar relación');
        }
      });
    }
  }

  removeRelation(relationId: number) {
    this.companyInvoiceRoutingService.removeAssociation(relationId).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success('Relación eliminada correctamente');
        this.loadStartData();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message || 'Error al eliminar relación');
      }
    });
  }


  onAdminWarehouseSelected(fiscalWarehouse: any) {
    // console.log(`Relacionando fiscal ${fiscalWarehouse.id} con admin ${fiscalWarehouse.warehouseAdminId}`);
    // puedes agregar lógica adicional aquí si es necesario
  }



}